module.exports = __webpack_public_path__ + "static/tagging_screen-fbe4f5310200d001ae95e2a0de940d41.png";